export default __webpack_public_path__ + "static/media/responsive-video.43e4bdb5.mp4";